// Build information generated at compile time
export const buildInfo = {
  buildTime: new Date().toISOString(),
  buildTimestamp: Date.now(),
  userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'Server-side',
  location: typeof window !== 'undefined' ? window.location.href : 'Server-side',
};
